export default{"initial.centerLabel.centerLabel.text.appearing":a=>{if(a.attr)return[{initialAttr:{x:a.attr.x,y:a.attr.y}}]}};


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-features/src/center-label-extension/center-label.animation.js
// module id = null
// module chunks = 